import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class HpsDepartmentService extends SingleDepartmentService {
  readonly NAME: string = 'Hardware Pack';
  readonly DEPARTMENT_ID: number = undefined;
  readonly BRAND: 'sb' | 'daystar' = 'sb';

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('HPs') ||
      roles.includes('HpsChief') ||
      roles.includes('HpsSupervisor') ||
      roles.includes('HpsAdmin')
    ) {
      this.router.navigate(['/sb/hp/items']);
      return true;
    }
    if (roles.includes('HpsStandardsAdmin') || roles.includes('HpsEngineer')) {
      this.router.navigate(['/sb/efficiencies/Hardware Pack/records']);
      return true;
    }
    if (roles.includes('HpsLabelOperator')) {
      this.router.navigate(['/sb/hp/packing-box']);
      return true;
    }
    return false;
  }
}
